import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=1415f84d&scoped=true"
import script from "./TermsOfUse.js?vue&type=script&lang=js&external"
export * from "./TermsOfUse.js?vue&type=script&lang=js&external"
import style0 from "./TermsOfUse.scss?vue&type=style&index=0&id=1415f84d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1415f84d",
  null
  
)

export default component.exports